import {TextEncoder} from "encoding";
import Bottleneck from "bottleneck";
import Modbus from "../modbus_with_scheduler.js";
import {SerialPort}	from "webserial";
import * as usbutil from "../usbutil.js";
import Device from "../device.js";


class Module extends Device {
  static constructor() {
  }  
  constructor(serialPort) { 
    super(serialPort);
    
    this.id = "-";
    this.status = "-";        

    this.serialNumber = "-";
    this.value = "-";

    this.__serialPort = serialPort;


    jfermi.addEventListener("fermentationstart", this.fermentationstart_handler.bind(this));
    jfermi.addEventListener("fermentationstop", this.fermentationstop_handler.bind(this));
  }
  async initialize() {
    try {            

      await this.__serialPort.open({
        baudRate: 9600,
        dataBits: 8,
        parity: "none",
        stopBits: 1    
      });      


      await this.setValue(0);
      this.value = 0;


      this.usbProductName = (await this.__serialPort.getInfo()).usbProductName;
      this.usbSerialNumber = (await this.__serialPort.getInfo()).usbSerialNumber;    

      this.name = usbutil.getDeviceName(`${this.usbProductName}_${this.usbSerialNumber}`) || "valve_1i2o";      

      let endpoint = `${this.usbProductName}_${this.usbSerialNumber}`;
      /* publicate remote methods to clients */
      jfermi[`RM_${endpoint}_setValue`] = this.RM_setValue.bind(this);      

      this.status = "OK";

    } catch(e) {
      this.status = `Failed: ${e}`;
      throw e;
    }
  }
  async update() {
    try {                          
      this.status = "Ok";
    } catch(e) {
      this.value = "-";
      this.status = `Failed: ${e}`;
      throw e;
    }      
  }
  async fermentationstart_handler() {    
  }
  async fermentationstop_handler() {        
  }  
  async setValue(value) {
    if (value) {
      // this will set the ftdi ttl cable #rts pin (usually green cable)
      // https://ftdichip.com/wp-content/uploads/2023/07/DS_TTL-232R_CABLES.pdf
      await this.__serialPort.setSignals({
        requestToSend: true
      });
      this.value = 1;
    } else {
      await this.__serialPort.setSignals({
        requestToSend: false
      });      
      this.value = 0;
    }
  }
  async RM_setValue(request, value) {
    try {
      await this.setValue(value);
      console.log(`${request.client.username}: Valve set to ${value}`);
    } catch(e) {
      console.error(`${request.client.username}: Failed to control valve: ${e.message}`);
      throw e;
    }   
  }
  toJSON() {
    return({
      name: this.name,            
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,
      status: this.status,      
      id: this.id,
      serialNumber: this.serialNumber,
      value: this.value
    });
  }
}

Module.constructor();

export default Module;